import CustomerUnlink from 'models/customer_unlink';

export default class UnlinkExternalCustomer {
  constructor(context) {
    this.context = context;
  }

  run({ customerId }) {
    let customerUnlink = CustomerUnlink.create({ customerId });

    this.context.stores.customerUnlink.setPending(customerUnlink);
    this.context.gateways.customerExtension.unlink(customerId);

    this.context.analytics.track('Customer Profile Unlinked', {
      customerId,
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/external_customer_lookup/unlink_external_customer.js